import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FiltersState {
  selectedAgency: string;
  selectedStatus: string;
  selectedOrder: string;
  selectedLineItems: string;
  selectedMediaType: string;
  selectedRateType: string;
  selectedExchangeType: string;
  selectedAdFormat: string;
  startDate: string;
  endDate: string;
  chartServedImp : number;
  dataBy: 'day' | 'week' | 'month' | 'quarter' | 'year';
  isTopNavReady: boolean;
}

const initialState: FiltersState = {
  selectedAgency: "",
  selectedStatus: "Active",
  selectedOrder: "",
  selectedLineItems: "",
  selectedMediaType: "",
  selectedRateType: "",
  selectedExchangeType: "",
  selectedAdFormat: "",
  startDate: "",
  endDate: "",
  chartServedImp : 0,
  dataBy: 'week',
  isTopNavReady: false
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setSelectedAgency(state, action: PayloadAction<string>) {
      state.selectedAgency = action.payload;
    },
    setSelectedStatus(state, action: PayloadAction<string>) {
      state.selectedStatus = action.payload;
    },
    setSelectedOrder(state, action: PayloadAction<string>) {
      state.selectedOrder = action.payload;
    },
    setSelectedLineItems(state, action: PayloadAction<string>) {
      state.selectedLineItems = action.payload;
    },
    setSelectedMediaType(state, action: PayloadAction<string>) {
      state.selectedMediaType = action.payload;
    },
    setSelectedRateType(state, action: PayloadAction<string>) {
      state.selectedRateType = action.payload;
    },
    setSelectedExchangeType(state, action: PayloadAction<string>) {
      state.selectedExchangeType = action.payload;
    },
    setSelectedAdFormat(state, action: PayloadAction<string>) {
      state.selectedAdFormat = action.payload;
    },
    setStartDate(state, action: PayloadAction<string>) {
      state.startDate = action.payload;
    },
    setEndDate(state, action: PayloadAction<string>) {
      state.endDate = action.payload;
    },
    setChartServedImp(state, action: PayloadAction<number>) {
      state.chartServedImp = action.payload;
    },
    setDataBy(state, action: PayloadAction<'day' | 'week' | 'month' | 'quarter' | 'year'>) {
      state.dataBy = action.payload;
    },
    setTopNavReady(state, action: PayloadAction<boolean>) {
      state.isTopNavReady = action.payload;
    },
    clearFilters(state) {
      state.selectedMediaType = "";
      state.selectedRateType = "";
      state.selectedExchangeType = "";
      state.selectedAdFormat = "";
    },
    clearAllUserData(state) {
      state.selectedAgency = "";
      state.selectedOrder = "";
      state.selectedLineItems = "";
      state.selectedMediaType = "";
      state.selectedRateType = "";
      state.selectedExchangeType = "";
      state.selectedAdFormat = "";
      state.startDate = "";
      state.endDate = "";
      state.chartServedImp = 0;
      state.dataBy = 'week';
      state.isTopNavReady = false;
      // Keep selectedStatus as "Active" as it's the default
      state.selectedStatus = "Active";
    },
  },
});

export const {
  setSelectedAgency,
  setSelectedStatus,
  setSelectedOrder,
  setSelectedLineItems,
  setSelectedMediaType,
  setSelectedRateType,
  setSelectedExchangeType,
  setSelectedAdFormat,
  setStartDate,
  setEndDate,
  setChartServedImp,
  setDataBy,
  setTopNavReady,
  clearFilters,
  clearAllUserData,
} = filtersSlice.actions;

export default filtersSlice.reducer;